import React, { useContext, useMemo } from 'react'
import { Sequence, useVideoConfig } from 'remotion'
import { ItemSelectedForCropContext, useItem } from '../contexts'
import { FEATURE_CROP_BACKGROUNDS } from '../crop'
import { InnerLayer } from './InnerLayer'
import { MEDIA_PREMOUNT_SECONDS } from './premount'

const sequenceStyle: React.CSSProperties = { display: 'contents' }
const styleWhilePremounted: React.CSSProperties = { display: 'block' }

export function Layer({
  itemId,
  trackMuted,
}: {
  itemId: string
  trackMuted: boolean
}) {
  const { fps } = useVideoConfig()
  const item = useItem(itemId)
  const itemSelectedForCrop = useContext(ItemSelectedForCropContext)
  const itemIsBeingCropped = item.id === itemSelectedForCrop
  // Zealous: media loads well ahead (#77): a scene's player fetches its start over
  // the network the first time it plays, and 1.5 s was not enough to keep
  // the preview from pausing there. Other items need little.
  const premountFor = useMemo(
    () =>
      (item.type === 'video' || item.type === 'audio'
        ? MEDIA_PREMOUNT_SECONDS
        : 1.5) * fps,
    [fps, item.type],
  )

  return (
    <Sequence
      key={item.id}
      from={item.from}
      style={sequenceStyle}
      durationInFrames={item.durationInFrames}
      styleWhilePremounted={styleWhilePremounted}
      premountFor={premountFor}
    >
      {itemIsBeingCropped && FEATURE_CROP_BACKGROUNDS ? (
        <InnerLayer cropBackground item={item} trackMuted />
      ) : null}
      <InnerLayer cropBackground={false} item={item} trackMuted={trackMuted} />
    </Sequence>
  )
}
